import { userActions, login } from '../rootTypes';

const INITIAL_STATE = {
  user: {
    attributes: {},
  },
  signedIn: false,
  notAuthorized: false,
  fetching: true,
  fetched: false,
};

const userState = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case userActions.fetchRequest:
      return { ...state, fetching: true };
    case userActions.fetchPending:
      return { ...state, user: { ...state.user, ...action.payload } };
    case userActions.fetchSuccess:
      return {
        ...state,
        user: { ...state.user, ...action.payload },
        signedIn: true,
        fetching: false,
        notAuthorized: false,
        fetched: true,
      };
    case userActions.fetchFailure:
      return {
        ...state,
        fetching: false,
        user: { ...INITIAL_STATE.user },
        signedIn: false,
      };
    case userActions.logout:
      return { ...INITIAL_STATE, fetching: false };
    case login.failure:
      return {
        ...state,
        notAuthorized: true,
      };
    default:
      return { ...state };
  }
};

export default userState;
